import React from 'react'
import GrillaAdjuntoSiniestro from '../../moleculas/GrillaAdjuntos/GrillaAdjuntoSiniestro'
import { useParams } from 'react-router-dom'
import { Titulo } from 'asocomponents'

export default function GrillaAdjuntoSiniestroContainer() {

    const nroSiniestro = useParams().nroSiniestro

    return (
        <div>
            <div>            
                <Titulo titulo="Documentos Digitalizados" />
            </div>
            <div className='mt-5'>
                <GrillaAdjuntoSiniestro nroSiniestro={nroSiniestro} />
            </div>
        </div>
    )
}
